// Storefront theming utilities

export const THEME_PRESETS = [
  { key: "coral",     name: "Coral (default)", accent: "#FF7E67" },
  { key: "berry",     name: "Berry",           accent: "#C2185B" },
  { key: "sunny",     name: "Sunny",           accent: "#F4A83B" },
  { key: "mint",      name: "Mint",            accent: "#4C9F70" },
  { key: "ocean",     name: "Ocean",           accent: "#2F80ED" },
  { key: "lavender",  name: "Lavender",        accent: "#8E7CC3" },
  { key: "cocoa",     name: "Cocoa",           accent: "#7A5230" },
  { key: "rose",      name: "Rose",            accent: "#EA6D9E" },
];

export const BANNER_STYLES = [
  { key: "gradient", label: "Gradient" },
  { key: "solid",    label: "Solid color" },
  { key: "photo",    label: "Photo (upload)" },
];

// Convert a hex color to a lighter shade for gradient partners.
function shade(hex, percent) {
  const m = hex.replace("#", "").match(/^([0-9a-f]{6})$/i);
  if (!m) return hex;
  const num = parseInt(m[1], 16);
  const amt = Math.round(2.55 * percent);
  const r = Math.max(0, Math.min(255, (num >> 16) + amt));
  const g = Math.max(0, Math.min(255, ((num >> 8) & 0xff) + amt));
  const b = Math.max(0, Math.min(255, (num & 0xff) + amt));
  return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}

// Compute the CSS background for a shop banner based on theme.
export function bannerBackground(seller, uploadedBannerUrlAbs) {
  const accent = seller?.theme_accent || "#FF7E67";
  const style = seller?.theme_banner_style || (seller?.banner_url ? "photo" : "gradient");
  if (style === "photo" && uploadedBannerUrlAbs) {
    return `url('${uploadedBannerUrlAbs}') center/cover`;
  }
  if (style === "solid") {
    return accent;
  }
  // gradient (default)
  return `linear-gradient(135deg, ${shade(accent, 25)} 0%, ${accent} 100%)`;
}

// Return the accent color, safely defaulting.
export function accentColor(seller) {
  return seller?.theme_accent || "#FF7E67";
}
